var map = {
	"./0_HelloStep.svg": [
		5511,
		511
	],
	"./1_Kyb.svg": [
		8242,
		242
	],
	"./1_SettingsAutoConversion.svg": [
		4354,
		354
	],
	"./1_SettingsSecurity.svg": [
		8729,
		729
	],
	"./2_Projects.svg": [
		6151,
		151
	],
	"./3_BalancesTopUp.svg": [
		4973,
		973
	],
	"./3_WithdrawaWhitelistStep.svg": [
		7094,
		94
	],
	"./4_MassPayouts.svg": [
		9420,
		420
	],
	"./5_CryptocurrencyConversion.svg": [
		3050,
		50
	],
	"./6_CheckoutsCreate.svg": [
		2064,
		64
	],
	"./7_PaymentsLink.svg": [
		7031,
		31
	],
	"./8_TransactionHistory.svg": [
		3824,
		443
	],
	"./9_OnRampWidget.svg": [
		1839,
		839
	],
	"./preload.svg": [
		1635,
		635
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7460;
module.exports = webpackAsyncContext;